var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCrops = function SvgCrops(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777776",
    fillRule: "nonzero",
    d: "M13.371 19.895v-7.457c4.115-.38 7.505-3.886 7.62-8.114v-.61c0-.647-.496-1.143-1.143-1.143H19.2c-4.343.115-8 3.772-8.114 8.153v.228c-1.41-1.447-3.353-2.4-5.486-2.476l-.99-.038c-.305 0-.61.114-.839.343a1.182 1.182 0 0 0-.342.838l.038.952c.076 4.115 3.504 7.543 7.619 7.734v1.59a1 1 0 0 0 1 1h.285a1 1 0 0 0 1-1zM18.63 4.933c-.381 2.629-2.629 4.877-5.22 5.22.381-2.63 2.591-4.877 5.22-5.22zM5.752 10.8c2.743.229 5.067 2.552 5.258 5.257-2.743-.19-5.067-2.552-5.258-5.257z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrops, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crops.cfdfcb67.svg";
export { ForwardRef as ReactComponent };